import { LeadCollectorMobileTicket } from './LeadCollectorMobileTicket';
import { CategoryList } from '@entities/category/ui/CategoryList';
import { TicketInfo } from '@shared/hooks/useFetchQrCode';
import { palette } from '@shared/tokens/palette.stylex';
import { SminexEventIcon } from '@shared/assets/icons';
import { useMobile } from '@shared/hooks/useMobile';
import { QrCode } from '@shared/ui/qr-code';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface LeadCollectorTicketProps {
  ticketInfo: TicketInfo;
  qr: string;
}

export const LeadCollectorTicket = ({ ticketInfo, qr }: LeadCollectorTicketProps) => {
  const isMobile = useMobile();

  if (isMobile) {
    return <LeadCollectorMobileTicket ticketInfo={ticketInfo} qr={qr} />;
  }

  const { eventName, categories, additionalGuests, firstName, lastName } = ticketInfo;
  const { adultCounter, adultGuests, adultGuestsLabel, childCounter, childGuests, childGuestLabel } = additionalGuests;
  const isHasAdditionalGuests = adultCounter || childCounter;

  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.logo)}>
        <SminexEventIcon colorPrimary={palette['grey-950']} colorSecondary={palette['bronze-500']} height={16} />
      </div>

      <div {...stylex.props(styles.main)}>
        <div {...stylex.props(styles.qr)}>
          <span {...stylex.props(styles.label)}>
            {isHasAdditionalGuests ? 'Групповой билет' : 'Персональный билет'}
          </span>

          <span {...stylex.props(styles.eventName)}>{eventName}</span>

          <div {...stylex.props(styles.categories)}>
            <CategoryList categories={categories} />
          </div>

          {!!isHasAdditionalGuests && (
            <div {...stylex.props(styles.counter)}>
              {!!adultCounter && (
                <>
                  <span>{adultCounter} взрослых</span>
                  <span>•</span>
                </>
              )}

              <span>{childCounter} детей</span>
            </div>
          )}

          <div {...stylex.props(styles.qrCode)}>
            <QrCode svg={qr} />
            <span {...stylex.props(styles.qrDescription)}>Предъявите QR для прохода на мероприятие</span>
          </div>
        </div>

        <div {...stylex.props(styles.guests)}>
          <div {...stylex.props(styles.mainGuest)}>
            <span {...stylex.props(styles.label)}>Основной гость</span>

            <span>
              {firstName} {lastName}
            </span>
          </div>

          {!!adultCounter && (
            <div {...stylex.props(styles.additionalGuests)}>
              <span {...stylex.props(styles.label)}>{adultGuestsLabel || 'Взрослые гости'}</span>

              <div {...stylex.props(styles.guestsList)}>
                {adultGuests.map(({ firstName, lastName, surname }, index) => (
                  <span key={`${firstName}-${lastName}-${surname}-${index}`}>
                    {lastName} {firstName} {surname}
                  </span>
                ))}
              </div>
            </div>
          )}

          {!!childCounter && (
            <div {...stylex.props(styles.additionalGuests)}>
              <span {...stylex.props(styles.label)}>{childGuestLabel || 'Маленькие гости'}</span>

              <div {...stylex.props(styles.guestsList)}>
                {childGuests.map(({ firstName, lastName, surname }, index) => (
                  <span key={`${firstName}-${lastName}-${surname}-${index}`}>
                    {lastName} {firstName} {surname}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
